import React, { useState } from 'react';
import ConsultantCheckoutContext from 'src/contexts/consultantCheckout';
import { IFullAppointmentData } from 'src/environments/CheckoutConsultantAPP/interfaces';

export default function ConsultantCheckoutProvider({ children }): JSX.Element {
  const [fullAppointmentData, setFullAppointmentData] = useState<IFullAppointmentData>();

  const contextValue = {
    fullAppointmentData,
    setFullAppointmentData,
  };

  return (
    <ConsultantCheckoutContext.Provider value={contextValue}>
      {children}
    </ConsultantCheckoutContext.Provider>
  );
}
